import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { routes } from '../../../constants'
import { actions } from '../certificadoDigital.actions'
import { CertificadoDigitalForm } from './CertificadoDigitalForm'
import _ from 'lodash'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
  return {
    record: state.crudCertificadoDigitalState.currentRecord,
    messages: state.crudCertificadoDigitalState.messages,
    uploading: state.crudCertificadoDigitalState.adicionandoAnexo,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    loadById: (oid) => dispatch(actions.loadById(oid)),
    processaCertificado: (event, password) => dispatch(actions.processaCertificado(event, password)),
  }
}

class CertificadoDigitalFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDialogRemove: false,
      certificadoPassword: '',
    }

    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_CERTIFICADO_DIGITAL}/${oid}`)
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_CERTIFICADO_DIGITAL}/novo`)
    }
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_CERTIFICADO_DIGITAL}`)
    }

    actions.beforeFetchRecordSuccess = (data) => {
      return data
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
    } else {
      this.props.newHandler()
    }
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_CERTIFICADO_DIGITAL}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  onChangeField = (fieldName, value) => {
    const field = _.get(value, 'target.name', null)
    if (field === 'ativo') {
      this.props.setField(field, _.get(value, 'target.checked', null))
      return
    }
    this.props.setField(fieldName, value)
  }

  onChangeCertificadoPassword = (value) => {
    this.setState({ certificadoPassword: value })
  }

  onUploadCertificado = (event) => {
    this.props.processaCertificado(event, this.state.certificadoPassword)
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  render() {
    const content = (
      <CertificadoDigitalForm
        record={this.props.record}
        messages={this.props.messages}
        onChangeField={this.onChangeField}
        onUploadCertificado={this.onUploadCertificado}
        onChangeCertificadoPassword={this.onChangeCertificadoPassword}
        certificadoPassword={this.state.certificadoPassword}
        uploading={this.props.uploading}
      />
    )

    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CertificadoDigitalFormPageContainer)
